import { lazy } from 'react';

const Login = lazy(() => import('./login'));
const LoginPO = lazy(() => import('./login-po'));
const SignUpPO = lazy(() => import('./sign-up-po'));
const ResetPassword = lazy(() => import('./reset-password'));
const ForgotPassword = lazy(() => import('./forgot-password'));

export { Login, LoginPO, SignUpPO, ResetPassword, ForgotPassword };
